import {Component, OnInit} from '@angular/core';
import {CarouselResponsiveOptions} from 'primeng/carousel';
import {DEFAULT_FEATURES, Step} from '../../../models/CarouselConfigs';
import {ViewportService} from '../../../services/viewport.service';

@Component({
    selector: 'features', templateUrl: './features.component.html', styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {
    partnerId: string;
    numVisible: number;
    steps: Step[] = DEFAULT_FEATURES.map(s => ({ ...s }));

    responsiveOptions2: CarouselResponsiveOptions[] = [
        {breakpoint: '1024px', numVisible: 3, numScroll: 1},
        {breakpoint: '949px', numVisible: 2, numScroll: 1},
        {breakpoint: '768px', numVisible: 2, numScroll: 1},
        {breakpoint: '680px', numVisible: 1, numScroll: 1},
        {breakpoint: '480px', numVisible: 1.1, numScroll: 1}];

    constructor(public viewport: ViewportService) {}

    ngOnInit(): void {}
}
